import moment from "moment";
import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import styles from "./styles.module.scss";

import { customTableStylesReport, fallbackIfEmpty } from "utils/Utils";

const Table = ({ dados, loading, actionFilter, totalRecords }) => {
  const statusFormater = (status) => {
    switch (status) {
      case "NOT_ATTEMPTED":
        return "Não iniciado";
      case "IN_PROGRESS":
        return "Em progresso";
      case "COMPLETED":
        return "Concluído";
      case "EXPIRED":
        return "Expirado";
      case "APPROVED":
      case "PASSED":
        return "Aprovado";
      case "REJECTED":
      case "FAILED":
        return "Reprovado";
      case "DISAPPROVED":
        return "Reprovado";
      default:
    }
  };

  const modalityFormater = (modality) => {
    switch (modality) {
      case "ASYNCHRONOUS":
        return "Assíncrono";
      case "BLENDED":
        return "Blended";
      default:
        return "Assíncrono";
    }
  };

  const columns = [
    {
      name: "Nome do usuário",
      selector: "name",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.name)}
        </span>
      ),
    },
    {
      name: "Login do usuário",
      selector: "username",
      sortable: true,
      center: true,
      wrap: true,
      width: "280px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.username)}
        </span>
      ),
    },
    {
      name: "Status do usuário",
      selector: "userStatus",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
    },
    {
      name: "Código do colaborador",
      selector: "employeeCode",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.employeeCode),
    },
    {
      name: "Empresa",
      selector: "company",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.company),
    },
    {
      name: "Cargo",
      selector: "role",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.role),
    },
    {
      name: "Departamento",
      selector: "department",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.department),
    },
    {
      name: "Unidade",
      selector: "unit",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.unit),
    },
    {
      name: "Filial",
      selector: "branch",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.branch),
    },
    {
      name: "Gestor imediato",
      selector: "manager",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.manager),
    },
    {
      name: "Nome do treinamento",
      selector: "title",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.title),
    },
    {
      name: "Modalidade",
      selector: "modality",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => <>{modalityFormater(d.modality)}</>,
    },
    {
      name: "Carga horária",
      selector: "workload",
      sortable: true,
      center: true,
      wrap: false,
      width: "200px",
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {d.workload > 0
            ? new Date(d.workload * 1000).toISOString().substring(11, 16)
            : d.workload || "-"}
        </span>
      ),
    },
    {
      name: "Nome da turma",
      selector: "team",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.team),
    },
    {
      name: "Progresso",
      selector: "progress",
      sortable: true,
      center: true,
      wrap: false,
      style: { textAlign: "center" },
      cell: (d) => <span>{d.progress}%</span>,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => <>{statusFormater(d.status)}</>,
    },
    {
      name: "Data de inscrição",
      selector: "enrollDate",
      sortable: true,
      center: true,
      wrap: false,
      width: "200px",
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {d.enrollDate ? moment(d.enrollDate).format("DD/MM/YYYY") : "-"}
        </span>
      ),
    },
    {
      name: "Data do primeiro acesso",
      selector: "startDate",
      sortable: true,
      center: true,
      wrap: false,
      width: "200px",
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {d.startDate ? moment(d.startDate).format("DD/MM/YYYY HH:mm") : "-"}
        </span>
      ),
    },
    {
      name: "Data de finalização",
      selector: "finishDate",
      sortable: true,
      center: true,
      wrap: false,
      cell: (d) => (
        <span>{d.finishDate ? moment(d.finishDate).format("DD/MM/YYYY HH:mm") : "-"}</span>
      ),
    },
    {
      name: "Nota",
      selector: "grade",
      sortable: true,
      center: true,
      wrap: false,
      style: { textAlign: "center" },
      cell: (d) => <span>{d.grade ?? "-"}</span>,
    },
    {
      name: "Gerou o certificado?",
      selector: "certificateGeneratedDate",
      sortable: true,
      center: true,
      wrap: false,
      cell: (d) => <span>{Boolean(d.certificateGeneratedDate) ? "SIM" : "NÃO"}</span>,
    },
  ];

  // const customTableStyles = {
  //   table: {
  //     style: {
  //       tableLayout: "auto", // permite largura dinâmica das colunas
  //     },
  //   },
  //   cells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal", // permite quebra de linha
  //       overflow: "visible",
  //       textOverflow: "unset",
  //       wordBreak: "break-word",
  //       width: "150px",
  //     },
  //   },
  //   headCells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal",
  //       fontWeight: "bold",
  //       position: "relative", // necessário para que o sortable fique absoluto em relação ao th
  //       padding: "0 0 0 12px", // espaço pro ícone
  //     },
  //   },
  //   sortIcon: {
  //     style: {
  //       position: "absolute",
  //       top: "50%",
  //       right: "8px",
  //       transform: "translateY(-50%)",
  //       pointerEvents: "none", // opcional, evita que o clique no ícone interfira
  //     },
  //   },
  // };

  const tableData = {
    columns: columns,
    data: dados,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Matrículas por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * dados.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => {
    return (
      <div className="tela-login-loading">
        <div className="loader-container" style={{ margin: "300px 0" }}>
          <div
            style={{
              position: "initial",
              margin: "initial",
            }}
            className="loader loader-center loader-big"
          ></div>
          <span
            style={{
              marginTop: 10,
              fontSize: 20,
            }}
          >
            Carregando dados...
          </span>
        </div>
      </div>
    );
  };

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={true}
      export={false}
    >
      <DataTable
        columns={columns}
        data={dados}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
